import {
  FETCH_VENDING_MACHINE_TAGS,
  RESET_VENDING_MACHINE_TAGS,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
  selectList: [],
};

const vendingMachineTagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VENDING_MACHINE_TAGS:
      return { list: action.payload };
    case RESET_VENDING_MACHINE_TAGS:
      return initialState;
    default:
      return state;
  }
};

export default vendingMachineTagsReducer;
